import { createRouter, createWebHistory } from 'vue-router';
import Dashboard from './components/Dashboard.vue';
import authService from "./services/authService";

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('./components/Login.vue'),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    beforeEnter: (to, from, next) => {
      if (authService.isAuthenticated()) {
        next();
      } else {
        next('/');
      }
    },
    // routes enfants correspondant aux "pages" que le Dashboard chargeait dynamiquement
    children: [
      { path: '', redirect: 'accueil' },
      { path: 'accueil', name: 'dashboard-accueil', component: () => import('./components/Statistiques.vue') },
      { path: 'questionnaire', name: 'dashboard-questionnaire', component: () => import('./components/questionnaire/Questionnaire.vue') },
      { path: 'bluetooth-capteur', name: 'dashboard-bluetooth-capteur', component: () => import('./components/NewBluetoothCapteur2.vue') },
      { path: 'bfp', name: 'dashboard-bfp', component: () => import('./components/bfp/bfpComponent.vue') },
      { path: 'list-psy', name: 'dashboard-list-psy', component: () => import('./components/admin/listTherapeute.vue') },
      { path: 'list-user', name: 'dashboard-list-user', component: () => import('./components/listUser.vue') },
      { path: 'maj', name: 'dashboard-maj', component: () => import('./components/MajListComponent.vue') },
      { path: 'scan3d-viewer', name: 'dashboard-scan3d-viewer', component: () => import('./components/jeu/Scan3dViewer.vue') },
      { path: 'statue3d-viewer', name: 'dashboard-statue3d-viewer', component: () => import('./components/jeu/Statue3dViewer.vue') },
      { path: 'fontaine3d-viewer', name: 'dashboard-fontaine3d-viewer', component: () => import('./components/jeu/Fontaine3dViewer.vue') },
      { path: 'particules3d-viewer', name: 'dashboard-particules3d-viewer', component: () => import('./components/jeu/Particules3dViewer.vue') },
      { path: 'zebre-viewer', name: 'dashboard-zebre-viewer', component: () => import('./components/jeu/zebre/ZebreViewer.vue') },
    ]
  },
  // Redirection pour toutes les pages inconnues — aller vers la page d'accueil du dashboard
  {
    path: '/:pathMatch(.*)*',
    redirect: '/dashboard/accueil',
  },
];

const router = createRouter({
  // Définir le bon chemin de base pour correspondre à l'emplacement du serveur
  history: createWebHistory(),
  routes,
});

export default router;